export default [
  {
    path: '/reportList',
    name: 'reportList',
    meta: {
      title: '上报线索'
    },
    component: () => import(/* webpackChunkName:'driverTest' */ './index.vue')
  }
];
